// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2E52h","box":"WorkspacesBox_box__12blK","node":"WorkspacesBox_node__3fdgk"};